/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Stage_CreatedInputs */

const tr_geliver_tracking_stage_created = /** @type {(inputs: Geliver_Tracking_Stage_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oluşturuldu`)
};

const en_geliver_tracking_stage_created = /** @type {(inputs: Geliver_Tracking_Stage_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const de_geliver_tracking_stage_created = /** @type {(inputs: Geliver_Tracking_Stage_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt`)
};

const ru_geliver_tracking_stage_created = /** @type {(inputs: Geliver_Tracking_Stage_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создано`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Geliver_Tracking_Stage_CreatedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_stage_created = /** @type {((inputs?: Geliver_Tracking_Stage_CreatedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Stage_CreatedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_stage_created(inputs)
	if (locale === "de") return de_geliver_tracking_stage_created(inputs)
	if (locale === "ru") return ru_geliver_tracking_stage_created(inputs)
	return tr_geliver_tracking_stage_created(inputs)
});